import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {updateLastUpdateTimestamp, updateSalesOrders} from '../ducks/orders';

class OrdersUpdateButton extends React.Component {
    /* Component for updating orders from Profit.
     * Holds the loading state until the page is refreshed - does not initially check if the orders are being updated or
     * not rather than just listens to last update property change after the button is clicked.
     * After the timestamp has changed, changes the button to look different and indicates that the user should reload
     * the page after they are done with the current activities on the page.
     */
    static propTypes = {
        lastUpdate: PropTypes.string,
        updateLastUpdateTimestamp: PropTypes.func.isRequired,
        updateSalesOrders: PropTypes.func.isRequired,
    };

    static defaultProps = {
        lastUpdate: null,
    };

    static renderLastUpdate = (timestamp) => {
        let lastUpdateText = gettext('Last update time is unknown');
        if (timestamp) {
            const text = gettext('Last updated: %s');
            lastUpdateText = interpolate(text, [moment(timestamp).calendar()]);
        }
        return (
            <div className="text-center text-muted my-2"><small>{lastUpdateText}</small></div>
        );
    };

    constructor(props) {
        super(props);
        this.state = {
            isUpdatingOrders: false,
            showReloadButton: false,
        };
    }

    componentDidMount() {
        this.props.updateLastUpdateTimestamp();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isUpdatingOrders && this.props.lastUpdate !== nextProps.lastUpdate) {
            this.setState({
                isUpdatingOrders: false,
                showReloadButton: true,
            });
        }
    }

    updateOrders() {
        if (this.state.isUpdatingOrders) {
            return;
        }
        this.setState({
            isUpdatingOrders: true,
        });
        this.props.updateSalesOrders();
    }

    render() {
        let button = null;
        if (this.state.showReloadButton) {
            button = (
                <button type="button" className="btn btn-success btn-block" onClick={() => location.reload(true)}>
                    {gettext("Reload page")}
                </button>
            );
        } else {
            button = (
                <button type="button" className="btn btn-outline-primary btn-block" onClick={() => this.updateOrders()}>
                    {this.state.isUpdatingOrders ?
                        <FontAwesomeIcon icon="spinner" pulse /> :
                        gettext("Refresh Profit orders")}
                </button>
            );
        }
        return (
            <div>
                {button}
                {OrdersUpdateButton.renderLastUpdate(this.props.lastUpdate)}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    lastUpdate: state.orders.lastUpdate,
});

const mapDispatchToProps = dispatch => ({
    updateSalesOrders: () => dispatch(updateSalesOrders()),
    updateLastUpdateTimestamp: () => dispatch(updateLastUpdateTimestamp()),
});

const OrdersUpdateButtonConnector = connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrdersUpdateButton);


export default OrdersUpdateButtonConnector;



// WEBPACK FOOTER //
// ./src/components/OrdersUpdateButton.js